import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Tally = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 10C26.854 10 26.716 10.032 26.591 10.088C26.591 10.088 26.379 10.184 26 10.357V5.00002C26 4.44802 25.552 4.00002 25 4.00002C24.448 4.00002 24 4.44802 24 5.00002V11.266C22.898 11.767 21.516 12.395 20 13.084V5.00002C20 4.44802 19.552 4.00002 19 4.00002C18.448 4.00002 18 4.44802 18 5.00002V13.993C16.688 14.589 15.329 15.207 14 15.811V5.00002C14 4.44802 13.552 4.00002 13 4.00002C12.448 4.00002 12 4.44802 12 5.00002V16.72C10.53 17.388 9.156 18.013 8 18.538V4.99902C8 4.44702 7.552 3.99902 7 3.99902C6.448 3.99902 6 4.44702 6 4.99902V19.447C5.108 19.852 4.58 20.093 4.579 20.093C4.237 20.252 4 20.598 4 20.999C4 21.551 4.448 21.999 5 21.999C5.147 21.999 5.286 21.967 5.412 21.909C5.412 21.909 5.622 21.813 6 21.642V26.999C6 27.551 6.448 27.999 7 27.999C7.552 27.999 8 27.551 8 26.999V20.733C9.102 20.232 10.484 19.604 12 18.915V26.999C12 27.551 12.448 27.999 13 27.999C13.552 27.999 14 27.551 14 26.999V18.006C15.312 17.41 16.672 16.792 18 16.188V26.999C18 27.551 18.448 27.999 19 27.999C19.552 27.999 20 27.551 20 26.999V15.279C21.47 14.611 22.844 13.986 24 13.461V27C24 27.552 24.448 28 25 28C25.552 28 26 27.552 26 27V12.552C26.892 12.147 27.42 11.906 27.421 11.906C27.763 11.747 28 11.401 28 11C28 10.448 27.552 10 27 10V10Z" />
	</svg>
);

export default Tally;
